import {TFunction} from "i18next";
import {Product} from "./product-service";

export const formatProductPrice = (t: TFunction, product: Pick<Product, 'price' | 'currency'>) =>
    t('signupBreeder.plan.price', {price: product.price ?? 0, currency: product.currency});

export const formatTaxHint = (t: TFunction, product: Pick<Product, 'includesTax'>) =>
    product.includesTax ? t('signupBreeder.plan.taxIncluded') : t('signupBreeder.plan.taxExcluded');
